import { Action } from 'redux-actions'

import { IPageInfoResponse } from '@/domains/CommonDomain'

export function apiSuccessReducer<S, A extends Action<any>>(state: S, action: A) {
  return {
    ...state,
    ...action.payload,
  }
}

export function apiFailureReducer<S>(state: S) {
  return {
    ...state,
    errorMessage: 'error',
  }
}

export function increasePage<S extends { pageInfo: IPageInfoResponse }>(state: S) {
  return {
    ...state,
    pageInfo: {
      ...state.pageInfo,
      curPage: state.pageInfo.curPage + 1,
    },
  }
}

export function reset<S>(state: S, initialState: S) {
  return {
    ...state,
    ...initialState,
  }
}
